// extracted by mini-css-extract-plugin
export default {"wrapper":"Blockquote_wrapper__uVsrO","blockquote":"Blockquote_blockquote__NmIku"};